import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';

/**
 * Badge that pulses ten times on mount, for active tickets (none under reduced motion).
 * Adds only the animation and fill: styling is MuiBadge in app/theme.js, placement on a tab
 * is CardTab. Use a plain <Badge> where no pulse is wanted.
 */
export const ActiveStyledBadge = styled(Badge)(({ theme }) => ({
  '@keyframes pulse': {
    from: {
      boxShadow: `0 0 0 0 ${(theme.vars || theme).palette.status.positiveChip}`,
    },
    to: {
      boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)',
    },
  },
  '& .MuiBadge-badge': {
    backgroundColor: (theme.vars || theme).palette.status.positiveChip,
    animation: 'pulse 1s 10 ease',
  },
}));

export default ActiveStyledBadge;
